import { useState, useEffect } from "react";
import { Grid, Box, Card } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { useTranslation } from "react-i18next";
import { apiError } from "../../lib/apiError";

import { AnalyticsPerilsList } from "./AnalyticsPerilsList";
import SelectReferenceDate from "../util/SelectReferenceDate";

import {
  GridAggregatedByCoverage,
  GridAggregatedByProvince,
  GridAggregatedByAgency,
  GridAggregatedByCommune,
  GridRiskLevels,
  GridBivariate,
} from "./ProvincesAndAgenziasNEW";
import { BivariateLegend } from "./BivariateLegend";
import { UniversalMap } from "../map/UniversalMap";
import httpClient from "../../lib/httpClient";
import { saveUserMonitorData } from "../util/userUtils";

export const ClimateDBList = () => {
  const { t } = useTranslation();

  const [filterModel, setFilterModel] = useState({});
  const [filteredMapData, setFilteredMapData] = useState(null);

  const [hazardSelect, setHazardSelect] = useState("anyhazard");
  const [KPISelect, setKPISelect] = useState("none");
  const [selectedComuneIstat, setSelectedComuneIstat] = useState(null);

  const [requestedTabIdx, setRequestedTabIdx] = useState(0);
  const [wantedReferenceDate, setWantedReferenceDate] = useState(null);
  const [listOfValidReferenceDates, setListOfValidReferenceDates] = useState([
    // To be loaded by the backend from catalog.
    "202212",
  ]);

  useEffect(() => {
    const getCatalog = async () => {
      saveUserMonitorData("analytics", "");

      try {
        const reply = await httpClient().get(`/analyticFilter/catalog`);

        const allReferenceDatesInCatalog = reply?.data?.allReferenceDatesInCatalog;
        if (Array.isArray(allReferenceDatesInCatalog)) {
          setListOfValidReferenceDates(allReferenceDatesInCatalog.reverse());

          // setListOfValidReferenceDates(allReferenceDatesInCatalog.reverse().concat("191711"));
          // RR-977E: add .concat("191711") after .reverse() to add the 191711 reference date to trigger an error message for debugging purposes.

          setWantedReferenceDate(allReferenceDatesInCatalog[0]);
        }
      } catch (error) {
        console.error("Error fetching catalog", error);
        apiError(error);
      }
    };
    getCatalog();
  }, []);

  const handleChange = (event, newValue) => {
    setRequestedTabIdx(newValue);
    saveUserMonitorData("analytics", `${newValue}`);
  };

  const handleWantedReferenceDateChange = (event) => {
    setWantedReferenceDate(event.target.value);
  };

  return (
    wantedReferenceDate && (
      <Grid style={{ marginTop: 25 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <Box>
              <Card>
                <UniversalMap
                  page="buildings-policies"
                  filteredMapDataProp={filteredMapData}
                  hazardSelect={hazardSelect}
                  setHazardSelect={setHazardSelect}
                  KPISelect={KPISelect}
                  setKPISelect={setKPISelect}
                  variantProp="ClimateAnalytics"
                  routeNameProp="policies"
                  setFilteredMapDataProp={setFilteredMapData}
                  filterModel={filterModel}
                  wantedReferenceDate={wantedReferenceDate}
                  selectedComuneIstatProp={selectedComuneIstat}
                />
              </Card>
            </Box>
          </Grid>

          <SelectReferenceDate
            wantedReferenceDate={wantedReferenceDate}
            handleWantedReferenceDateChange={handleWantedReferenceDateChange}
            listOfValidReferenceDates={listOfValidReferenceDates}
          />

          <AnalyticsPerilsList
            filterModel={filterModel}
            setFilterModel={setFilterModel}
            setFilteredMapData={setFilteredMapData}
            wantedReferenceDateProp={wantedReferenceDate}
          ></AnalyticsPerilsList>

          <Box p={1}>
            <AppBar position="static" color="default" elevation={0}>
              <Tabs value={requestedTabIdx} onChange={handleChange}>
                <Tab label={t("climateAnalyticsTabs.coverages")} />

                <Tab label={t("climateAnalyticsTabs.provinces")} />
                <Tab label={t("climateAnalyticsTabs.agencies")} />
                <Tab label={t("climateAnalyticsTabs.municipalities")} />
                <Tab label={t("climateAnalyticsTabs.riskLevels")} />
                <Tab label={t("climateAnalyticsTabs.legend")} />
                <Tab label={t("climateAnalyticsTabs.bivariate")} />
              </Tabs>
            </AppBar>
          </Box>

          {requestedTabIdx === 0 && (
            <GridAggregatedByCoverage
              filterModel={filterModel}
              wantedReferenceDateProp={wantedReferenceDate}
            />
          )}
          {requestedTabIdx === 1 && (
            <GridAggregatedByProvince
              filterModel={filterModel}
              wantedReferenceDateProp={wantedReferenceDate}
            />
          )}
          {requestedTabIdx === 2 && (
            <GridAggregatedByAgency filterModel={filterModel} wantedReferenceDateProp={wantedReferenceDate} />
          )}
          {requestedTabIdx === 3 && (
            <GridAggregatedByCommune
              filterModel={filterModel}
              wantedReferenceDateProp={wantedReferenceDate}
              setSelectedComuneIstatSetter={setSelectedComuneIstat}
            />
          )}
          {requestedTabIdx === 4 && (
            <GridRiskLevels
              filterModel={filterModel}
              hazardSelect={hazardSelect}
              KPISelect={KPISelect}
              wantedReferenceDateProp={wantedReferenceDate}
            />
          )}
          {requestedTabIdx === 5 && (
            <BivariateLegend
              hazardSelect={hazardSelect}
              KPISelect={KPISelect}
              wantedReferenceDateProp={wantedReferenceDate}
            />
          )}
          {requestedTabIdx === 6 && (
            <GridBivariate
              filterModel={filterModel}
              hazardSelect={hazardSelect}
              KPISelect={KPISelect}
              wantedReferenceDateProp={wantedReferenceDate}
              setSelectedComuneIstatSetter={setSelectedComuneIstat}
            />
          )}
        </Grid>
      </Grid>
    )
  );
};
